import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanLoad, Route, Router, RouterStateSnapshot, UrlSegment, UrlTree } from '@angular/router';
import { isNullOrUndefined, isValidString } from '@pineapplelab/util';
import { Observable } from 'rxjs';
import { AuthService } from '../../services/auth/auth.service';
import { UserService } from '../../services/user/user.service';
import { ProjectService } from '../../services/project/project.service';

@Injectable({
  providedIn: 'root'
})
export class HasPermissionsGuard {

  constructor(
    private authService: AuthService,
    private router: Router,
	private userService: UserService,
	private projectService: ProjectService
  ) { }

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    return this.checkPermission(route.data);
  }

  canActivateChild(
    childRoute: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    return this.checkPermission(childRoute.data);
  }

  canLoad(
    route: Route,
    segments: UrlSegment[]): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    return this.checkPermission(route.data);
  }

  checkPermission(routeData: any) {
    let access = true;
    const isSigned = this.authService.auth.user;
    const redirectIfNotLogged = isValidString(routeData?.redirectIfNotLogged) ? routeData?.redirectIfNotLogged : '/login';
    const redirectIfUnauthorized = isValidString(routeData?.redirectIfUnauthorized) ? routeData?.redirectIfUnauthorized : this.userService.getRoute(this.authService.auth?.user?.role);

	if (!isSigned && this.projectService.hasPermissions(routeData?.permission, routeData?.inclusive)) {
		return true;
	}

    if (!isSigned) {
      this.router.navigateByUrl(redirectIfNotLogged);
      return false;
    }

    if (!isNullOrUndefined(routeData) && !isNullOrUndefined(routeData.permission)) {
      access = this.authService.hasPermission(routeData.permission, routeData.inclusivePermission);
    }
    if (!access) {
      this.router.navigateByUrl(redirectIfUnauthorized);
    }
    return access;
  }

}
